import React from "react";

function FlexCrudScreenTypeLayout ( props ) {

    const { children } = props;


    let headerLayout;
    let contentLayout;
    let footerLayout;
    for (let idx in children) {

        if ( children[idx]?.props && children[idx]?.props.className ) {

            if ( children[idx]?.props.className.indexOf("basicCrudScreenHeaderLayout") >= 0) {
                headerLayout = children[idx];
            }
    
            if ( children[idx]?.props.className.indexOf("basicCrudScreenContentLayout") >= 0) {
                contentLayout = children[idx];
            }
    
            if ( children[idx]?.props.className.indexOf("basicCrudScreenFooterLayout") >= 0) {
                footerLayout = children[idx];
            }
    
        }
        
    }

    return (

        <div style={{display: "flex", flexDirection:"column", height: "100%"}}>
            <div style={{height: "48px"}}>
                {
                    headerLayout
                    ?
                    React.cloneElement(headerLayout)
                    :
                    <></>
                }
            </div>
            <div style={{height: "100%", overflow: "auto", flexGrow: 1, minHeight: 0,}}>
                {
                    contentLayout
                    ?
                    React.cloneElement(contentLayout)
                    :
                    <></>
                }
            </div>
            <div>
                {
                    footerLayout
                    ?
                    React.cloneElement(footerLayout)
                    :
                    <></>
                }
            </div>
        </div>

    );


}

export default FlexCrudScreenTypeLayout;

